export const BACKOUT_MESSAGES: any = {
  'BACKOUT MILEAGE RUNNING': 'Backout Process Ongoing...',
  'MILEAGE RUNNING': 'Mileage Process Ongoing...',
  'S': 'Completed',
  'FAILED': 'Failed',
};